<template>
  <div
    :class="{
      'flex h-full flex-col rounded-t-5px border border-b-5px border-b-www-color-primary-lighter bg-www-color-white': true,
      'border-www-color-neutral-very-light hover:border-www-color-neutral-light hover:border-b-www-color-primary-lighter': true,
      'manual transition-all duration-300 ease-in-out': true,
    }"
  >
    <div
      :class="{
        'img-contianer h-52 overflow-hidden': true,
      }"
    >
      <component
        :is="link ? GeneralLink : 'div'"
        _type="generalLink"
        :link="link?.link"
        text=""
        :class="{ 'block h-full w-full': true }"
      >
        <PtcPicture
          provider="sanity"
          :src="cardImage?.asset?._ref ?? ''"
          :img-attrs="{
            class: { 'aspect-video object-cover object-center rounded-t-5px w-full': true },
          }"
          :modifiers="{
            crop: cardImage?.crop,
            hotspot: cardImage?.hotspot,
            w: 400,
          }"
          :alt="resolvedImage?.altText || 'manual card image'"
        />
      </component>
    </div>
    <div
      :class="{
        'flex-grow px-6 pb-4 pt-8 text-www-color-neutral-medium-dark': true,
      }"
    >
      <h5
        :class="{
          'text-xl font-black capitalize text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ title }}
      </h5>

      <p
        :class="{
          'flex-grow text-15px leading-7 text-www-color-neutral-medium-dark': true,
        }"
      >
        {{ description }}
      </p>
    </div>
    <GeneralLink
      v-if="link?.text"
      v-bind="link"
      :class="{
        'link-wrapper inline-flex items-center gap-2.5 px-6 py-22px font-ptc-Rajdhani text-base font-bold uppercase text-www-color-primary-lighter': true,
      }"
    >
      <PtcIcon
        name="ptc-arrow-white"
        alt="arrow"
        :class="{
          'text-www-color-primary-lighter': true,
        }"
      />
    </GeneralLink>
  </div>
</template>

<script lang="ts" setup>
import GeneralLink from '~/components/Molecules/HeaderComponents/GeneralLink.vue';
import PtcPicture from '~/components/Atmos/PtcPicture/PtcPicture.vue';
import PtcIcon from '~/components/Atmos/PtcIcon/PtcIcon.vue';
import type { ManualCard } from '~/sanity/types';

const props = defineProps<ManualCard>();
const { getResolvedImage } = useRefsStore();
const resolvedImage = await getResolvedImage(props.cardImage?.asset?._ref);
</script>
<style>
.img-contianer a {
  width: 100%;
}
.link-wrapper span:first-of-type {
  display: flex;
  gap: 10px;
}
</style>
